import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { openForm, closeForm, fetchTileData } from '../tileForm/tileFormSlice';

const useShowTileForm = () => {
  const dispatch = useDispatch();

  const value = useMemo(
    () => ({
      createTile: () => {
        dispatch(openForm());
      },
      editTile: async ({ tileId }) => {
        dispatch(await dispatch(fetchTileData({ tileId })));
      },
      closeForm: () => dispatch(closeForm()),
    }),
    [dispatch],
  );

  return value;
};

export { useShowTileForm };
